import { BaseEntity } from './../../shared';
import { Sample } from './sample.model';

export class SampleList implements BaseEntity {
    constructor(
        public id?: number,
        public listName?: string,
        public description?: string,
        public active?: boolean,
        public samples?: Sample[]
    ) {
    }
}

export class StudySampleList {
    constructor(
        public listId?: number,
        public listName?: string,
        public description?: string,
        public notes?: string,
        public createdBy?: string,
        public takenBy?: string,
        public samplingDate?: Date,
        public cropName?: string,
        public parentId?: number,
        public createdDate?: Date,
        public programUUID?: string,

        // Creation from study
        public datasetId?: number,
        public selectionVariableId?: number,
        public instanceIds?: number[]) {
    }
}
